import { IonCol, IonImg, IonItem, IonList, IonRow, IonSkeletonText, IonSpinner, IonThumbnail } from '@ionic/react';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import { useEffect, useState } from 'react';

// Components
import { Input } from '@/components/Input';
// Styles
import styles from '@/components/ProfileModal/ProfileModalContent.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

import { useOrganizationLogo } from '@/hooks/useOrganizationLogos';
import { useScrollToInputWhenKeyboardOpens } from '@/hooks/useScrollToInputWhenKeyboardOpens';

// Context
import { useAuthContext } from '@/contexts/authContext';
import { useUserInfoContext } from '@/contexts/userInfoContext';

import { toast } from '../Toaster/Toast';

interface ProfileModalProps {
  cleanUp?: () => void;
}

export const ProfileModalContent = ({ cleanUp }: ProfileModalProps) => {
  const user = useAuthContext().state.userState?.user;
  const { userInfo } = useUserInfoContext();

  // const imgURL = new URL(`../../assets/clientProfileLogos/${userInfo.organization.logoURL}.png`, import.meta.url).href;

  const { logoURL, loading, error } = useOrganizationLogo({
    logoFileName: userInfo.organization.logoURL,
    logoType: 'profile',
  });

  useScrollToInputWhenKeyboardOpens();

  return (
    <div className={styles.wrapper}>
      <IonRow className='ion-align-items-center ion-justify-content-center ion-margin-top'>
        <IonCol className='ion-justify-content-center ion-text-center ion-margin-top' size='6'>
          {logoURL && !error ? (
            <IonImg
              alt='Organization Logo'
              src={logoURL}
              style={{ width: '75%', marginLeft: 'auto', marginRight: 'auto' }}
            />
          ) : (
            <IonSpinner color='primary' name='lines'></IonSpinner>
          )}
        </IonCol>
      </IonRow>
      <IonRow className='ion-align-items-center ion-justify-content-center' style={{ width: '100%' }}>
        <IonCol className='ion-margin-top' size='12'>
          <IonList class={mergeClassNames(styles['no-padding'], styles.list)} mode='md'>
            <Input
              disabled
              label='Name'
              labelPlacement='stacked'
              readonly={true}
              value={`${userInfo.firstName} ${userInfo.lastName}`}
              variant='light'
            />
            <br />
            <Input
              disabled
              label='Email'
              label-placement='stacked'
              readonly={true}
              value={user!.email!}
              variant='light'
            />
            <br />
            <Input
              disabled
              label='Organization'
              label-placement='stacked'
              readonly={true}
              value={userInfo.organization.org_name!}
              variant='light'
            />
          </IonList>
        </IonCol>
      </IonRow>
    </div>
  );
};
